import React from 'react'
import PropTypes from 'prop-types'
import HoverableProductTile from '../productTile/HoverableProductTile'
import ScrollableCarousel from '../../owlCarousel/ScrollableCarousel'
import './productCarousel.css.scss'

class ProductCarousel extends React.Component {
  render () {
    let carouselTitle
    if (this.props.title) {
      carouselTitle = (
        <div className='product-carousel-header'>
          <h2>{this.props.title}</h2>
          <div className='see-all-container'>
            <a
              className='see-more'
              href={`/explore/filter?categories=${this.props.link}`}
            >
              See All{' '}
            </a>
          </div>
        </div>
      )
    }

    const productTiles = this.props.products.map((product, idx) => (
      <div className='product' key={idx}>
        <HoverableProductTile product={product} hasDescription={false} />
      </div>
    ))

    return (
      <React.Fragment>
        <div className='product-carousel section-container'>
          <div className='carousel-content'>
            {carouselTitle}
            <div className='plans-block'>
              <div className='container-fluid'>
                <div className='row'>
                  <ScrollableCarousel>{productTiles}</ScrollableCarousel>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='products-grid mobile compact-xs'>
          {productTiles.slice(0, 4)}
        </div>
      </React.Fragment>
    )
  }
}

ProductCarousel.propTypes = {
  products: PropTypes.array,
  link: PropTypes.string,
  title: PropTypes.string
}

export default ProductCarousel
